var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.62695H4.16667H17.5",
    stroke: "#5B5B5B",
    strokeWidth: 1.17647,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 5.62826V17.2949C15.8327 17.737 15.6571 18.1609 15.3445 18.4734C15.032 18.786 14.608 18.9616 14.166 18.9616H5.83268C5.39065 18.9616 4.96673 18.786 4.65417 18.4734C4.34161 18.1609 4.16602 17.737 4.16602 17.2949V5.62826M6.66602 5.62826V3.96159C6.66602 3.51956 6.84161 3.09564 7.15417 2.78308C7.46673 2.47052 7.89065 2.29492 8.33268 2.29492H11.666C12.108 2.29492 12.532 2.47052 12.8445 2.78308C13.1571 3.09564 13.3327 3.51956 13.3327 3.96159V5.62826",
    stroke: "#5B5B5B",
    strokeWidth: 1.17647,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 9.79492V14.7949",
    stroke: "#5B5B5B",
    strokeWidth: 1.17647,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 9.79492V14.7949",
    stroke: "#5B5B5B",
    strokeWidth: 1.17647,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressTrash);
export default __webpack_public_path__ + "static/media/addressTrash.b1ad6b212907a3b40210472dc50cb910.svg";
export { ForwardRef as ReactComponent };